export default {
  CURSO: 15,
  OBSERVACOES: 17,
  JUSTIFICATIVA: 21,
  DISCIPLINA_MULTIPLA: 24,
  ANEXO: 25,
  DESCRICAO_SERVICO: 27,
  CURSO_GRADUACAO_SOLICITANTE: 28,
  NOME_EMPRESA: 33,
  NOME_RESPONSAVEL_EMPRESA: 34,
  EMAIL_RESPONSAVEL_EMPRESA: 37,
  TIPO_PESSOA: 38,
  CNPJ: 39,
  CPF: 40,
  TELEFONE_RESPONSAVEL_EMPRESA: 42,
  CELULAR_RESPONSAVEL_EMPRESA: 43,
  CEP_EMPRESA: 48,
  ENDERECO_EMPRESA: 49,
  NUMERO_EMPRESA: 50,
  BAIRRO_EMPRESA: 51,
  CIDADE_EMPRESA: 52,
  ESTADO_EMPRESA: 53,
  LOCAL_ESTAGIO: 58,
  SERIE_COLEGIO: 59,
  TURMA_COLEGIO: 62,
  DISCIPLINA_COLEGIO_MULTIPLO: 64,
  INFORMACOES_COMPLEMENTARES: 75,
  MOTIVO_TRANCAMENTO: 79,
  MOTIVO_TRANCAMENTO_ATENDENTE: 80,
  PERIODO_SOLICITADO: 82,
  MODALIDADE_ENSINO: 97
};



// WEBPACK FOOTER //
// ./src/domain/protocolo/CampoEnum.js